export default __webpack_public_path__ + "static/media/tom-ford.df2c2ff8.jpg";